import { useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import NotificationService from "../../services/notification";

function NotificationDetailModal({ notification, onClose }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function getDetail() {
      try {
        setLoading(true);
        setError("");

        const response = await NotificationService.getNotifById(
          notification._id,
        );

        setDetail(response.data.data);
      } catch (err) {
        setError("Failed to load notification details");
      } finally {
        setLoading(false);
      }
    }

    getDetail();
  }, [notification._id]);

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-md p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="font-bold text-gray-800">
            {detail?.title || notification.title}
          </h2>

          <IoIosClose
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 text-2xl cursor-pointer"
          />
        </div>

        {loading ? (
          <p className="text-center text-gray-500 py-8">
            loading notification ...
          </p>
        ) : error ? (
          <p className="text-sm text-red-500">{error}</p>
        ) : (
          <>
            <p className="text-sm text-gray-600 leading-7 whitespace-pre-wrap break-words">
              {detail?.body}
            </p>

            {detail?.ticket_subject && (
              <p className="text-sm text-gray-500 mt-3">
                ticket title: {detail.ticket_subject}
              </p>
            )}
          </>
        )}

        <p className="text-xs text-gray-400 mt-4">
          {new Date(notification.createdAt).toLocaleString()}
        </p>
      </div>
    </div>
  );
}

export default NotificationDetailModal;
